define([
	"dojo/_base/declare",
	"csi/xml",
	"./BOMSupplierAttributesMixin"
], function (declare, xml, BOMSupplierAttributesMixin) {

	return declare(BOMSupplierAttributesMixin, {

		_writeRequestParameters: function (/*CallMethod*/call) {
			this.inherited(arguments);

			// If grouped and action invoked from group (not from toolbar button)
			if (this._groupResults) {
				this._groupResults.every(function (groupResult, index) {
					const groupUrl = groupResult.groupValue;

					if (groupResult.level && groupResult.level.groupSpec) {
						const groupId = groupResult.level.groupSpec.heading.m_id;

						if (groupId === "DSSection") {
							// We only set the group value on the new node if the group is by DSSection on PartMaterial.
							// To avoid going through the loop again, we return false to break out of the loop.
							call.addParameter(groupId, xml.ATTR_REF, groupUrl);
							return false;
						}
					}
				});
			}
		}
	});
});